import { motion } from "framer-motion";
import { CheckCircle2, MessageCircle } from "lucide-react";
import { IMAGES, waLink, SERVICE_MESSAGES } from "@/lib/constants";

const EASE = [0.16, 1, 0.3, 1];

const SYMPTOMS = [
  "Volante torto",
  "Carro puxando para um lado",
  "Vibração no volante",
  "Pneus desgastando irregularmente",
  "Troca recente de pneus",
  "Impacto em buracos ou meio-fio",
];

export const GeometriaDetail = () => (
  <section id="balanceamento" className="py-20 lg:py-28 bg-[#E9ECF1]">
    <div className="px-4 sm:px-6 lg:px-10 max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
      >
        <p className="flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.3em] text-gray-500 mb-6">
          <span className="text-signal">02</span>
          <span className="h-px w-10 bg-signal/60" />
          Balanceamento e Geometria
        </p>
        <h2 className="font-display font-black uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl text-[#101218]">
          Seu carro está vibrando ou <span className="text-signal">puxando para um lado?</span>
        </h2>
        <p className="mt-6 text-sm sm:text-base text-gray-600 leading-relaxed max-w-xl">
          Uma geometria incorreta pode causar desgaste irregular dos pneus, alterar
          o comportamento do veículo e comprometer a dirigibilidade. O balanceamento
          também é fundamental para reduzir vibrações e proporcionar maior conforto.
        </p>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
          {SYMPTOMS.map((s) => (
            <div
              key={s}
              className="flex items-center gap-3 bg-white border border-black/[0.06] px-4 py-3.5 shadow-sm"
            >
              <CheckCircle2 className="h-5 w-5 text-signal shrink-0" />
              <span className="text-sm font-medium text-gray-800">{s}</span>
            </div>
          ))}
        </div>

        <a
          data-testid="alignment-whatsapp-button"
          href={waLink(SERVICE_MESSAGES.alignment)}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-cut mt-9 inline-flex items-center gap-2 px-8 py-4 bg-signal hover:bg-signalhover text-white font-display font-bold uppercase tracking-wide text-lg transition-colors duration-300"
        >
          <MessageCircle className="h-5 w-5" />
          Agendar Balanceamento e Geometria
        </a>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: 40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="relative"
      >
        <img
          src={IMAGES.alignmentDetail}
          alt="Equipamento de alinhamento e balanceamento"
          loading="lazy"
          className="w-full h-[420px] lg:h-[560px] object-cover border border-black/10"
        />
        <div className="absolute bottom-5 left-5 bg-ink/95 px-5 py-4 max-w-xs">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-volt">Tecnologia de precisão</p>
          <p className="mt-1.5 text-sm text-gray-300 leading-snug">
            Alinhamento e balanceamento com equipamento profissional.
          </p>
        </div>
      </motion.div>
    </div>
  </section>
);
